import * as React from 'react'
import { Site } from '@envato/foundation-types'

import FullWidthBannerBlock from '../../../components/categoryPage/fullWidthBannerBlock'
import { ILocationParams } from '../../../../common/reducers/reactRouterLocation'
import { ICommonLocation } from '../../../../common/utils/location/types'

import * as styles from './fullWidthBannerSection.module.css'

const fullWidthBannerData: any = {
  themeforest: {
    title: '50% off best-selling themes & web templates',
    subtitle: 'Get mega savings on WordPress themes, HTML templates and more!',
    buttonText: 'Save now',
    backgroundColor: '#5EEBCF',
    textColor: '#131419',
    url: 'https://envato.com/c/cybermonday-blackfriday/themes/',
    image: {
      url:
        'https://assets.shopfront.envato-static.com/images/categories/sale-campaign-2020-11-tf.png',
      alt: 'Cyber Monday Sale 2020'
    },
    gaLabel: 'cybermonday_sale_2020'
  },
  codecanyon: {
    title: '50% off best-selling plugins, scripts & code',
    subtitle: 'Get mega savings on WordPress plugins, PHP scripts and more!',
    buttonText: 'Save now',
    backgroundColor: '#5EEBCF',
    textColor: '#131419',
    url: 'https://envato.com/c/cybermonday-blackfriday/code/',
    image: {
      url:
        'https://assets.shopfront.envato-static.com/images/categories/sale-campaign-2020-11-cc.png',
      alt: 'Cyber Monday Sale 2020'
    },
    gaLabel: 'cybermonday_sale_2020'
  },
  videohive: {
    title: '50% off best-selling video templates',
    subtitle:
      'Get mega savings on After Effects files, Premiere Pro templates and more!',
    buttonText: 'Save now',
    backgroundColor: '#5EEBCF',
    textColor: '#131419',
    url: 'https://envato.com/c/cybermonday-blackfriday/video/',
    image: {
      url:
        'https://assets.shopfront.envato-static.com/images/categories/sale-campaign-2020-11-vh.png',
      alt: 'Cyber Monday Sale 2020'
    },
    gaLabel: 'cybermonday_sale_2020'
  },
  audiojungle: {
    title: '50% off best-selling audio tracks',
    subtitle: 'Get mega savings on royalty-free music, idents and more!',
    buttonText: 'Save now',
    backgroundColor: '#5EEBCF',
    textColor: '#131419',
    url: 'https://envato.com/c/cybermonday-blackfriday/audio/',
    image: {
      url:
        'https://assets.shopfront.envato-static.com/images/categories/sale-campaign-2020-11-aj.png',
      alt: 'Cyber Monday Sale 2020'
    },
    gaLabel: 'cybermonday_sale_2020'
  },
  graphicriver: {
    title: '50% off best-selling graphic templates',
    subtitle:
      'Get mega savings on Photoshop actions, presentation templates and more!',
    buttonText: 'Save now',
    backgroundColor: '#5EEBCF',
    textColor: '#131419',
    url: 'https://envato.com/c/cybermonday-blackfriday/graphics/',
    image: {
      url:
        'https://assets.shopfront.envato-static.com/images/categories/sale-campaign-2020-11-gr.png',
      alt: 'Cyber Monday Sale 2020'
    },
    gaLabel: 'cybermonday_sale_2020'
  }
}

const FullWidthBannerSection = ({
  makeSearchLink,
  currentSite,
  location,
  bgColor
}: {
  currentSite: Site
  location: ICommonLocation
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
  bgColor: string
}) => {
  if (!fullWidthBannerData[currentSite]) {
    return null
  }
  return (
    <section
      className={styles.fullWidthBannerSectionWrapper}
      style={{ background: bgColor }}
    >
      <div className={styles.fullWidthBannerWrapper}>
        <FullWidthBannerBlock
          location={location}
          locationParams={{}}
          componentType="FullWidthBannerBlock"
          makeSearchLink={makeSearchLink}
          currentSite={currentSite}
          data={fullWidthBannerData[currentSite]}
        />
      </div>
    </section>
  )
}

export default FullWidthBannerSection
